module.exports = __webpack_public_path__ + "img/445.fb693387.png";